import { useRouter } from "next/router";
import { CustomContent } from "@/components/CustomContent";
import { Box, Button, Typography } from "@mui/material";
import { ErrorVector, WaveDecorator } from "@/assets/vectors";
import theme from "@/styles/theme";
import { blueGrey } from "@mui/material/colors";
import { HiHome } from "react-icons/hi";
import { ArrowBack, CorporateFare } from "@mui/icons-material";
import { ROUTES } from "@/constants/Routes";
import { useUserStore } from "@/store/useUserStore";
import { useUserOrganizationStore } from "@/store/useUserOrganizationStore";
import { k2d } from "@/fonts/k2d";

export default function Custom500() {
	const userId = useUserStore(({ id }) => id);
	const organizationId = useUserOrganizationStore(
		({ organization }) => organization?.id
	);

	const router = useRouter();

	const redirect = {
		home: () => router.push(ROUTES.HOME),
		back: () => router.back(),
		organization: () =>
			router.push({
				pathname: ROUTES.ORGANIZATION.PROFILE,
				query: { userId },
			}),
	};

	return (
		<CustomContent.Root sx={{ height: "100vh" }}>
			<Box
				sx={{
					display: "flex",
					flex: 1,
					gap: 10,
				}}
			>
				<Box
					sx={{
						position: "relative",
						display: "flex",
						justifyContent: "center",
						alignSelf: "center",
						width: "52%",
					}}
				>
					<ErrorVector style={{ color: theme.palette.error.main }} />
				</Box>

				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						flex: 1,
						gap: 8,
					}}
				>
					<Box color={blueGrey[600]}>
						<Button
							size='small'
							color='inherit'
							startIcon={<ArrowBack style={{ paddingBottom: 2 }} />}
							onClick={redirect.back}
						>
							Voltar
						</Button>
					</Box>

					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							gap: 5,
							paddingRight: 10,
						}}
					>
						<Box>
							<Typography
								variant='h4'
								sx={{ opacity: 0.7 }}
								color={theme.palette.error.main}
								fontFamily={k2d.style.fontFamily}
							>
								Ops!
							</Typography>
							<Typography
								variant='h3'
								color={theme.palette.error.main}
								fontFamily={k2d.style.fontFamily}
								gutterBottom
							>
								Erro de acesso
							</Typography>
							<Box
								sx={{
									display: "flex",
									flexDirection: "column",
									gap: 2,
								}}
							>
								<Typography variant='body1' color={blueGrey[600]}>
									A página ou recurso que você está tentando acessar não está
									disponível no momento. Pode ser que ela tenha sido removida,
									movida ou que o endereço esteja incorreto. Se o problema
									persistir, entre em contato com o suporte.
								</Typography>
								<Typography variant='body1' color={blueGrey[600]}>
									Como você deseja prosseguir?
								</Typography>
							</Box>
						</Box>

						<Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
							<Button
								variant='contained'
								startIcon={<HiHome />}
								onClick={redirect.home}
								color='error'
							>
								Página Inicial
							</Button>

							{organizationId && (
								<Button
									variant='outlined'
									startIcon={<CorporateFare />}
									onClick={redirect.organization}
									color='error'
								>
									Minha Organização
								</Button>
							)}
						</Box>
					</Box>
				</Box>
			</Box>

			<WaveDecorator
				style={{
					position: "absolute",
					bottom: "-2%",
					opacity: 0.08,
					color: theme.palette.error.main,
					width: "95%",
				}}
			/>
		</CustomContent.Root>
	);
}
